import React from "react";
import * as Animate from "react-reveal";

const DigitalTransformationSection = () => {
  return (
    <section className="pt-14">
      <div className="container mx-auto px-4">
        <div className="w-full lg:w-8/12 xl:w-7/12">
          <Animate.Fade bottom>
            <h2 className="text-default text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
              AI-powered hiring & payroll OS for global teams
            </h2>

            <p className="mt-8 text-sm-15 lg:text-base xl:text-lg lg:leading-7 xl:leading-8 w-full lg:w-10/12">
              Utiva AI Agent OS is a comprehensive platform that automates the
              entire hiring and payroll process for global teams. It's a
              one-for-all solution for all your hiring and payroll needs.
            </p>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default DigitalTransformationSection;
